import json from "../json/pluginStatus.json";

export default async () => JSON.parse(JSON.stringify(await json));
